<div class="container">
  <h1>Testimonials</h1>

  <h3>Below are some reviews taken from Google maps...</h3>

  <br>

  <div *ngFor="let testimonial of testimonials$ | async" class="testimonialsContainer">

    <mat-card class="example-card">
      <mat-card-title>{{ testimonial.googleUsername }}</mat-card-title>
      <mat-card-subtitle>{{ testimonial.date | date : 'MMMM yyyy'}}</mat-card-subtitle>
      <mat-card-content>
        <p>
          {{ testimonial.review }}
        </p>
      </mat-card-content>
    </mat-card>
    <br />
  </div>

</div>